import types from '../mutation-types';

import { REPLY_EDITOR_MODES } from 'dashboard/components/widgets/WootWriter/constants';
import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

// Pass B H9 — per-account draft storage.
//
// Previously drafts were stored under a single global `draftMessages`
// JSON store keyed by conversationId. A conversationId is unique only
// within an account, so when a user belonged to two accounts a draft
// could leak across the boundary.
//
// Now reads/writes are scoped under `draftMessages::<accountId>` (via
// LocalStorage.accountScopedStoreName). The shape of the per-account
// store is unchanged: a plain `{ <conversationId-mode>: text }` map.
// The `key` passed in is still the (conversationId, replyMode) tuple
// computed by the conversation components.

const state = () => ({
  records: {},
  replyEditorMode: REPLY_EDITOR_MODES.REPLY,
});

export const getters = {
  get: _state => key => {
    return _state.records[key] || '';
  },
  getReplyEditorMode: _state => _state.replyEditorMode,
};

export const actions = {
  set: async ({ commit, rootGetters }, { key, message }) => {
    commit(types.SET_DRAFT_MESSAGES, { key, message });
    const accountId = rootGetters.getCurrentAccountId;
    if (accountId) {
      LocalStorage.updateAccountScopedJsonStore(
        LOCAL_STORAGE_KEYS.DRAFT_MESSAGES,
        accountId,
        key,
        message
      );
    }
  },
  delete: ({ commit, rootGetters }, { key }) => {
    commit(types.SET_DRAFT_MESSAGES, { key });
    const accountId = rootGetters.getCurrentAccountId;
    if (accountId) {
      LocalStorage.deleteFromAccountScopedJsonStore(
        LOCAL_STORAGE_KEYS.DRAFT_MESSAGES,
        accountId,
        key
      );
    }
  },
  setReplyEditorMode: ({ commit }, { mode }) => {
    commit(types.SET_REPLY_EDITOR_MODE, { mode });
  },
};

export const mutations = {
  [types.SET_DRAFT_MESSAGES]($state, { key, message }) {
    $state.records = {
      ...$state.records,
      [key]: message,
    };
  },
  [types.REMOVE_DRAFT_MESSAGES]($state, { key }) {
    const { [key]: draftToBeRemoved, ...updatedRecords } = $state.records;
    $state.records = updatedRecords;
  },
  [types.SET_REPLY_EDITOR_MODE]($state, { mode }) {
    $state.replyEditorMode = mode;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
